import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Author from '../global/Author';
import { Data, Link } from '../../components';

const PostTeaser = props => {
  const {
    title,
    excerpt,
    featured,
    featuredImage,
    author,
    authorUrl,
    link,
  } = props;

  const classes = cx('post__teaser', {
    'post__teaser--featured': featured,
  });

  return (
    <article className={classes}>
      {featured && (
        <div className="u-textCenter u-textLeft@medium u-mb--regular">
          <h5 className="u-textMuted u-mb--remove">Featured Post</h5>
          <h4 className="u-textFluid--h2-h3 u-mt--remove">
            <Link className="u-textHDefault u-linkUnderline" to={link}>
              <Data>{title}</Data>
            </Link>
          </h4>
        </div>
      )}
      {featured ? (
        <Link to={link} className="post__teaser-hero--featured">
          <img src={featuredImage} alt="" />
        </Link>
      ) : (
        <Link
          to={link}
          className="post__teaser-hero"
          style={{ backgroundImage: `url(${featuredImage})` }}
        />
      )}
      <div className="post__teaser-content">
        {!featured && (
          <h4 className="u-textLarge">
            <Link className="u-textHDefault u-linkUnderline" to={link}>
              <Data>{title}</Data>
            </Link>
          </h4>
        )}
        <div className="u-textSmall u-mb--regular">
          <Data markdown>{excerpt}</Data>
        </div>
        <Author name={author} url={authorUrl} />
      </div>
    </article>
  );
};

PostTeaser.propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  featured: PropTypes.bool,
  featuredImage: PropTypes.string,
  author: PropTypes.string,
  authorUrl: PropTypes.string,
  link: PropTypes.string.isRequired,
};

export default PostTeaser;
